<template>
  <div>
    <h5>產品選項</h5>
    <br />
    <div
      v-for="(item, idx) in orderList"
      :key="idx"
    >
    <div class="card"
      style="
        padding: 10px;
        box-shadow: 1px 1px 3px 1px #eee;
        margin-bottom: 5px;
        background: #fff;
        "
        v-show="item.isDisplay">
      <h6>{{ item.name }}</h6>
      <div class="row">
        <div class="col" v-if="useDateCompulsory">
          <div style="border-right: 1px solid #ddd">
            <h6 style="text-align: right; margin-bottom: 15px" class="unselect">
              &nbsp;
            </h6>
            <div style="margin-top: 15px; padding-right: 15px">
              <div class="input-group flex-nowrap">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="placeholder"                  
                  v-model="item.date"
                  @click.stop="showCalendar(item.id)"                  
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="padding-left: 15px">
          <h6 style="text-align: right; margin-bottom: 15px">
            {{ item.currency }} {{ item.price }}
          </h6>
          <input  type="number" 
          :min="item.min" :max="item.max" :step="item.step" 
          v-model="item.qty" @change.stop="qtyChanged(item)" v-ep-restrict.alpha.number/>
        </div>        
      </div>
      <template v-if="inputList.length > 0">
        <div class="row">
            <div v-for="(input, idx) in inputList" :key="idx">
              <APIList
                v-if="input.type.toUpperCase() == 'APILIST' "
                :inputList="inputList"
                :customInput="input"
                :orderInput="item"
                :mode="mode"
              />
           </div>      
      </div>
      </template>
    </div>
    
  </div>
  </div>
  <Modal v-model="isShowModal" :close="closeModal">
      <div class="modal">
        <Calendar :productId="productId" :productCode="productCode" />
      </div>
    </Modal>
</template>

<script>
import { ref, nextTick, onMounted, onBeforeUnmount } from "vue";
import useEventBus from "@/config/eventBus";
import Calendar from "@/components/Calendar.vue";
import APIList from "@/widgets/APIList.vue";

export default {
  props: {
     inputList: {
       type: Array,
       required: true,
    },
    orderList: {
      type: Array,
      required: true,
    },
    productCode: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    useDateCompulsory: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Calendar,
    APIList,
  },
  data: () => ({	    
    mode: "write",
  }),
  setup(props) {
    const eventBus = useEventBus();
    const isShowModal = ref(false);
    const productId = ref(0);
    const placeholder = "輸入使用日期";

    const showCalendar = (id) => {
      console.log(id);
      productId.value = id;
      isShowModal.value = true;
      $("html").css({
        overflowY: "hidden",
      });
    };
    const qtyChanged = (item) => {        
        console.log("qtyChanged:");
        eventBus.emit("productOptionSelected", {
            item:item
          });
      };
    const closeModal = () => {
      isShowModal.value = false;
      $("html").css({
        overflowY: "auto",
      });
    };

    const handleNextTick = async () => {
      await nextTick();
      $("input[type='number']").inputSpinner();
    };

    onMounted(() => {
      handleNextTick();

      eventBus.on("closeModal", () => {
        closeModal();
      });

      eventBus.on("selectDateEvent", (_obj) => {
        closeModal();
        console.log("selectDateEvent");
        console.log(_obj);
        console.log(props.orderList);
        for(var i =0;i<props.orderList.length;i++){
            if(props.orderList[i].itemId==_obj.itemId){
              qtyChanged(props.orderList[i]);
            }
        }
      });
      eventBus.on("filterItems", (argv) => {
          if(argv[0]==0) return;
          props.orderList.forEach(function (item) {
            item.isDisplay = false;            
            for(var i=0;i<argv.length;i++){                             
                if(item.id==argv[i]) {
                    item.isDisplay = true;
                }
            }
          });
          props.orderList.forEach(function (item) {
              if(!item.isDisplay){
            	  item.date = placeholder;      
            	  console.log('filter reset');                  
                  item.qty=0;
              }
            });
      });
    });
    eventBus.on("resetSelectedValue", (questionKey) => {
    	props.orderList.forEach(function (item) {
    		item.date = placeholder;                  
            item.qty=0;
          });
    	$("input[type=number]").val(0);
      });
    
    onBeforeUnmount(() => {
      eventBus.off("closeModal");
      //eventBus.off("selectDateEvent");
    });

    return {
      showCalendar,
      qtyChanged,
      isShowModal,
      closeModal,
      productId,
    };
  },
};
</script>

<style scoped>
.card {
  padding: 0;
}
.row {
  margin: 0;
  padding: 5px;
}
.col {
  padding: 0;
}
</style>